import moment from 'moment';

import { GetLocationUsableSkills, } from 'helpers/api-calls/skill-calls';
import { loadMoreCalendarShifts, } from 'helpers/api-calls/calendar-shift-calls';
import { moreShiftsLoading, moreShiftsLoaded, cancelShiftsLoading, newShiftsLoaded, } from '../../../../actions/calendar-actions';
import { getApplicantsInBulk} from 'helpers/api-calls/shift-calls';

import actions from './actions';
import { appActions } from 'App/duck';

const getLocationUsableSkills = (locationId) => (dispatch) => 
  GetLocationUsableSkills(locationId).then(({data}) =>{
    dispatch(appActions.hydrateSkills(data.skills));
  }).catch((error) =>{
    const msg = `${locationId}: GetLocationUsableSkills returns error = ${error}`;
    console.log(msg);
  });

const getMoreCalendarShiftsOperation = (start, end, pageNum, perPageNum) => (dispatch) => {
    dispatch(moreShiftsLoading());
    return loadMoreCalendarShifts(start, end, pageNum, perPageNum).then(({data}) =>{
      if ( pageNum == 1) {
        dispatch(newShiftsLoaded(data.schedule_elements));
      }else{
        dispatch(moreShiftsLoaded(data.schedule_elements));
      }
    }).catch((error) =>{
      const msg = `getMoreCalendarShiftsDispatch returns error = ${error}`;
      console.log(msg);
      dispatch(cancelShiftsLoading());
    });
}

const loadApplicantsForShiftOperation = (applicantIDs, locationId) => (dispatch) => {

  return getApplicantsInBulk(applicantIDs, locationId).then((response) => {
    // console.log(JSON.stringify(response));
    const payload = { applicants: response.data.applicants };
    dispatch(actions.hydrateApplicants(payload));

  }).catch((error) => {
    console.log(`loadApplicantsForShiftOperation error: ${error}`);
  });
}

export default {
  getLocationUsableSkills,
  getMoreCalendarShiftsOperation,
  loadApplicantsForShiftOperation,
};
